module.exports = __webpack_public_path__ + "static/media/29DUNON4.025b0bd5.jpg";